module.exports = __webpack_public_path__ + "static/media/Skill-illustration.19d7c555.svg";